/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Search': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<path pid="0" d="M18.697 16.78l.015-.007.011-.011c.192-.182.278-.487.256-.78-.022-.29-.153-.592-.426-.77l-3.852-3.66c.793-1.09 1.111-2.328 1.111-3.562 0-3.943-3.319-7.09-7.456-7.09C4.219.9.9 4.047.9 7.99c0 3.944 3.319 7.09 7.456 7.09 1.789 0 3.581-.607 4.903-1.826l3.692 3.508c.181.172.533.338.886.338.182 0 .32-.044.452-.107.06-.028.119-.06.18-.094l.014-.008a4.1 4.1 0 01.214-.111zM8.356 2.809c3.056 0 5.458 2.29 5.458 5.181 0 2.892-2.402 5.182-5.458 5.182-3.055 0-5.458-2.29-5.458-5.182 0-2.891 2.403-5.181 5.458-5.181z" _fill="#fff" _stroke="#fff" stroke-width=".2"/>'
  }
})
